(function () {
  function getSelectedOptions(variantSelectsEl) {
    return Array.from(variantSelectsEl.querySelectorAll('fieldset'))
      .map((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      })
      .filter(Boolean);
  }

  function getOptionFieldsets(variantSelectsEl) {
    return Array.from(variantSelectsEl.querySelectorAll('fieldset.js.product-form__input'));
  }

  function getCheckedValue(fieldset) {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function findVariantByOptions(variants, selectedOptions) {
    const key = selectedOptions.join('||');
    return variants.find((v) => Array.isArray(v.options) && v.options.join('||') === key);
  }

  function updateSelectedLabel(variantSelectsEl, changedInput) {
    const fieldset = changedInput.closest('fieldset');
    if (!fieldset) return;

    const legend = fieldset.querySelector('.form__label');
    if (!legend) return;

    const labelSpan = legend.querySelector('[data-siw-selected-label]');
    if (!labelSpan) return;

    labelSpan.textContent = changedInput.value;
  }

  function setButtonState(form, isAvailable) {
    if (!form) return;
    const btn = form.querySelector('button[type="submit"][name="add"]');
    if (!btn) return;

    const textSpan =
      btn.querySelector('[data-siw-add-text]') ||
      btn.querySelector('span') ||
      null;

    if (isAvailable) {
      btn.disabled = false;
      btn.classList.remove('disabled');
      if (textSpan) textSpan.textContent = 'Add to cart';
    } else {
      btn.disabled = true;
      btn.classList.add('disabled');
      if (textSpan) textSpan.textContent = 'Sold out';
    }
  }

  async function updateCardVariant(variantSelectsEl, input) {
    const card = variantSelectsEl.closest('.product-style-it-with__card');
    if (!card) return;

    const productUrl = variantSelectsEl.dataset.url;

    const variantsScript =
      card.querySelector('script[data-siw-variants]') ||
      variantSelectsEl.querySelector('script[data-siw-variants]');

    let variants = [];
    try {
      variants = JSON.parse((variantsScript && variantsScript.textContent) || '[]');
    } catch (e) {
      variants = [];
    }
    const form = card.querySelector('form.siw-product-form');
    const idInput = form ? form.querySelector('input[name="id"].product-variant-id') : null;

    const selectedOptions = getSelectedOptions(variantSelectsEl);
    const matched = findVariantByOptions(variants, selectedOptions);

    try {
    card.classList.add("is-loading");

    const html = await fetchVariantHTML(productUrl, matched.id);
    if (!html) return;

    const doc = parseHTML(html);
    updateOptionStates(variantSelectsEl, variants, input);
    updatePriceFromDoc(card, doc);
     if (!matched) {
      if (idInput) idInput.value = '';
      setButtonState(form, false);
      return;
    }

    if (idInput) idInput.value = matched.id;

    setButtonState(form, matched.available !== false);

  } catch (err) {
    console.error("SIW fetch variant failed", err);
  } finally {
    card.classList.remove("is-loading");
  }

  }

  function updatePriceFromDoc(card, doc) {
    const newPrice = doc.querySelector(".price");
    const priceContainer = card.querySelector("[data-siw-price]");
    
    if (newPrice && priceContainer) {
      priceContainer.innerHTML = newPrice.outerHTML;
    }
  }

  function getValueState(variants, selectedOptions, optionIndex, testValue) {
    const testOptions = [...selectedOptions];
    testOptions[optionIndex] = testValue;

    const matching = variants.filter(v => {
      if (!Array.isArray(v.options)) return false;
      return v.options.every((opt, i) => opt === testOptions[i]);
    });

    if (!matching.length) return "unavailable";
    if (matching.some(v => v.available)) return "available";
    return "soldout";
  }

  function setInputState(input, state) {
    const label = input.closest('fieldset')?.querySelector(`label[for="${input.id}"]`);

    if (state === "available") {
      input.classList.remove("disabled");
    }

    if (state === "soldout") {
      input.classList.add("disabled");
    }

    if (state === "unavailable") {
      input.classList.add("disabled");
    }
  }

  function updateOptionStates(variantSelectsEl, variants, input) {
    const fieldsets = getOptionFieldsets(variantSelectsEl);
    const selectedOptions = getSelectedOptions(variantSelectsEl);

    fieldsets.forEach((fieldset, optionIndex) => {
      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const optionPosition = (fieldset.dataset.optionPosition || "").toLowerCase();
      if (optionPosition < input.dataset.optionPosition){
        return;
      }

      radios.forEach((radio) => {
        const state = getValueState(variants, selectedOptions, optionIndex, radio.value);
        setInputState(radio, state);
      });
    });

  }
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (!input || input.type !== 'radio') return;

    const variantSelectsEl = input.closest('div[data-siw="true"]');
    if (!variantSelectsEl) return;

    updateSelectedLabel(variantSelectsEl, input);
    updateCardVariant(variantSelectsEl, input);
  });



  function initSIWSingle(root) {
    const slides = Array.from(root.querySelectorAll('[data-siw-slide]'));
    const prevBtn = root.querySelector('[data-siw-prev]');
    const nextBtn = root.querySelector('[data-siw-next]');

    if (!slides.length) return;

    let index = slides.findIndex(s => s.dataset.active === 'true');
    if (index === -1) index = 0;

    function update() {
      slides.forEach((slide, i) => {
        slide.dataset.active = i === index ? 'true' : 'false';
      });

      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (index > 0) {
          index--;
          update();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (index < slides.length - 1) {
          index++;
          update();
        }
      });
    }

    update();
  }

  async function fetchVariantHTML(productUrl, variantId) {
    const url = `${productUrl}?variant=${variantId}`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return null;
    return await res.text();
  }

  function parseHTML(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc;
  }


  document.addEventListener('DOMContentLoaded', function () {
    
    document
      .querySelectorAll('[data-style-it-with]')
      .forEach(initSIWSingle);
  });

})();
